import { useColorMode, useEventListener, usePreferredDark } from '@vueuse/core'

const { store, system, state } = useColorMode({
  emitAuto: true,
  selector: 'html',
  attribute: 'data-theme',
  modes: {
    light: 'decklight',
    dark: 'deckdark'
  }
})

const prefersDark = usePreferredDark()

// L'impression force un fond blanc : en thème sombre, le texte resterait clair.
const html = document.documentElement
useEventListener('beforeprint', () =>
  html.setAttribute('data-theme', 'decklight')
)
useEventListener('afterprint', () =>
  html.setAttribute(
    'data-theme',
    state.value === 'dark' ? 'deckdark' : 'decklight'
  )
)

export function useDarkMode() {
  return { store, system, state, prefersDark }
}
